module.exports = __webpack_public_path__ + "img/thybault.b75253d8.jpg";